import { optionsFunction } from "./_config";
import axios from "axios";

export const checkRewards = () => axios.get(`api/rewards`, optionsFunction());
export const collectRewards = () =>
  axios.post(`api/rewards`, {}, optionsFunction());
